/**
 * Положена ли игроку новость о рейтинговых обличиях в главном меню (см.
 * RankSkinsNewsModal): только вошедшему игроку, сыгравшему хотя бы один
 * сетевой матч — обычный или рейтинговый (рейтинговые входят в
 * onlineGamesPlayed; локальные бои с ботами и обучение — нет), и только пока
 * он ее не закрыл. Признак показа приходит с сервером: null — неизвестно
 * (путь профиля его не прислал), и тогда новость не показывается.
 *
 * Очередь модалок меню (новость — самая низкоприоритетная) решает само меню.
 *
 * @param {Object} params
 * @param {string|null} [params.userId]
 * @param {boolean} [params.isGuest]
 * @param {number|null} [params.onlineGamesPlayed]
 * @param {number|null} [params.rankedGamesPlayed]
 * @param {boolean|null} [params.hasSeenRankSkinsNews]
 * @returns {boolean}
 */
export const checkIfRankSkinsNewsDue = ({
  userId,
  isGuest,
  onlineGamesPlayed,
  rankedGamesPlayed,
  hasSeenRankSkinsNews,
}) => {
  if (!userId || isGuest || hasSeenRankSkinsNews !== false) {
    return false;
  }

  return onlineGamesPlayed > 0 || rankedGamesPlayed > 0;
};
